module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-retry-d2a95dda.svg";